export const REPORTEDBY_EMAIL = 1
export const REPORTEDBY_CHAT = 2
export const REPORTEDBY_PHONE = 3
export const REPORTEDBY_OTHER = 4
export const REPORTEDBY_SMS = 5
export const REPORTEDBY_FACEBOOK = 6
export const REPORTEDBY_CONTACT_REQUEST = 7
